import { memo } from "react";

function Icon_MidstreamHighlight() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM5.464 4.04C6.248 4.04 6.88 4.672 6.88 5.464C6.88 6.248 6.248 6.88 5.464 6.88C4.672 6.88 4.04 6.248 4.04 5.464C4.04 4.672 4.672 4.04 5.464 4.04ZM10.576 12C9.792 12 9.16 11.36 9.16 10.576C9.16 9.792 9.792 9.16 10.576 9.16C11.36 9.16 12 9.792 12 10.576C12 11.36 11.36 12 10.576 12ZM5.2 12.024L4 10.824L10.824 4L12.024 5.2L5.2 12.024Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(Icon_MidstreamHighlight);
